import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {MessageInfo, ServerResponse} from '../models';
import {PopupMessageTypes, ServerErrors} from '@app/shared/dictionaries';
import { PopupMessageSummaries } from '@app/shared/dictionaries';
import { RestService } from './rest.service';
import { Subject } from 'rxjs/Subject';


@Injectable()
export class PopupService {
  private showMessageSubject = new Subject<MessageInfo>();
  private clearMessagesSubject = new Subject<null>();
  public showPopupTariffRestriction_message: string;

  constructor(private restService: RestService) {
    this.restService.getRequestExceptionSub().subscribe(response => {
      if (response && response.Result) {
        if (response.Result.ReturnCode !== ServerErrors.TariffRestriction) {
          const message = new MessageInfo();
          message.severity = PopupMessageTypes.Error;
          message.detail = response.Result.Message;
          message.summary = PopupMessageSummaries.Error;
          this.showMessage(message);
        } else {
          this.showPopupTariffRestriction_message = response.Result.Message;
        }
      }
    });
  }

  public getSubscription(): Observable<MessageInfo> {
    return this.showMessageSubject.asObservable();
  }

  public showMessage(message: MessageInfo) {
    this.showMessageSubject.next(message);
  }

  public clearMessages(): void {
    this.clearMessagesSubject.next();
  }

  public getClearSubscription(): Observable<null> {
    return this.clearMessagesSubject.asObservable();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/popup.service.ts